var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" Scatter Chart ")]),_c('ScatterChart',{ref:"scatterRef",staticStyle:{"border":"1px solid #000000"},attrs:{"chartData":_vm.chartData5,"options":_vm.chartOptions5}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }